module.exports = __webpack_public_path__ + "static/media/v1.bbc9bf3b.svg";